import React, { useMemo } from 'react';
import { FormattedDate } from 'components/FormattedDate/FormattedDate';
import { useSavedFiltersModalBLoC } from 'components/modals/SavedFiltersModal/SavedFiltersModal.bloc';
import { useObservableState } from 'observable-hooks';
import { DetailsPanelContentMetaStyle as S } from './DetailsPanelContentMeta.style';

export const DetailsPanelContentMeta: React.FC = () => {
  const { $selectedFilter, $projects } = useSavedFiltersModalBLoC();
  const selectedFilter = useObservableState($selectedFilter);
  const projects = useObservableState($projects);
  const filterProjectName = useMemo(
    () => projects?.find((p) => p.id === selectedFilter?.projectId)?.name,
    [selectedFilter, projects]
  );

  return (
    <S.Container>
      {filterProjectName && <li data-testid="label-saved-filters-project-name">{filterProjectName}</li>}
      {selectedFilter?.createdAt && (
        <li data-testid="label-saved-filters-created-at">
          <FormattedDate date={selectedFilter?.createdAt} format="EEE, d MMMM yyyy" />
        </li>
      )}
      {selectedFilter?.createdBy && (
        <li data-testid="label-saved-filters-created-by">{selectedFilter?.createdBy}</li>
      )}
    </S.Container>
  );
};
